import { Box, Skeleton, Stack, useTheme } from "@mui/material";
import { ProductImagesProps } from "../types";
import { useEffect, useState } from "react";

const ProductImages = ({ productData }: ProductImagesProps) => {
  const theme = useTheme();
  const [selectedCarImage, setSelectedCarImage] = useState<any>();

  useEffect(() => {
    if (productData?.images?.length > 0) {
      setSelectedCarImage(productData.images[0].url);
    }
  }, [productData]);
  return (
    <Stack width={{ xs: "100%", md: "50%" }}>
      {selectedCarImage ? (
        <img
          loading="lazy"
          src={selectedCarImage}
          alt="main-product"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "300px",
            objectFit: "contain",
            marginBottom: "16px",
          }}
        />
      ) : (
        <Skeleton variant="rounded" height={300} />
      )}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: "100%",
          overflowX: "auto",
          py: 1,
          "&::-webkit-scrollbar": { height: 4 },
        }}
      >
        {productData?.images?.length > 0 &&
          productData?.images?.map((img: { url: string }, index: number) => (
            <Box
              key={index}
              onClick={() => setSelectedCarImage(img.url)}
              sx={{
                border:
                  selectedCarImage === img.url
                    ? `2px solid ${theme.palette.primary.main}`
                    : "2px solid transparent",
                borderRadius: 2,
                cursor: "pointer",
                overflow: "hidden",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  border:
                    selectedCarImage === img.url
                      ? `2px solid ${theme.palette.primary.main}`
                      : `2px solid ${theme.palette.grey[400]}`,
                },
              }}
            >
              <img
                key={index}
                loading="lazy"
                src={img?.url}
                onClick={() => setSelectedCarImage(img?.url)}
                alt={`thumb-${index}`}
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />
            </Box>
          ))}
      </Stack>
    </Stack>
  );
};

export { ProductImages };
